export default class IAPMenuController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  async show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    //get loading model
    const modelLoading = this.getModelLoading()

    app.populate(pageId, modelLoading);
    app.swapPage(pageId);

    //get model
    const model = await this.getModel();

    app.populate(pageId, model);
    app.swapPage(pageId);

  }
   getModelLoading(){
    const app = this.app;
    const userdata = app.userdata;
    let coins = userdata.coins || 0;
    let fullVersion = userdata.fullVersion;

    let model = {
      coins: coins,
      items: [],
      fullVersion: fullVersion,
      isLoading: true
    }
    return model;
  }
  async getModel(){
    const app = this.app;
    const userdata = app.userdata;
    const IAP = app.IAP;
    const items = app.items;


    let coins = userdata.coins || 0;
    let removeAds = userdata.removeAds;
    let fullVersion = userdata.fullVersion;
    let catalog = await IAP.getCatalog() || [];

    let itemsAll = items.allItems.filter((i) => {
      if (i.type !== "IAP") return false;
      if (removeAds && i.id === "app.cardgames.cribbage.removeads") return false;
      let product = catalog.find(j => j.productId === i.id);
      if (!product) return false;
      if (!product.canPurchase) return false;
      return true;
    });
    let itemsModel = itemsAll.map((i) => {
      let product = catalog.find(j => j.productId === i.id);
      if (!product) return false;
      return {
        id: i.id,
        name: product.name || i.name,
        icon: product.icon || i.icon,
        title: product.title || i.title,
        description: product.description || i.description,
        price: product.price
      };
    });
    let model = {
      coins: coins,
      items: itemsModel,
      fullVersion: fullVersion,
      isLoading: false
    }
    return model;
  }
}